module.exports = __webpack_public_path__ + "static/media/AVAX.47be62e8.svg";